import React from "react";
import { useTheme } from "../context/ThemeContext";
import { Moon, Sun } from "lucide-react";

const DarkModeToggle = () => {
  const { theme, toggle } = useTheme();
  const dark = theme === "dark";
  return (
    <button
      type="button"
      onClick={toggle}
      data-testid="dark-mode-toggle"
      aria-label={dark ? "Activer mode clair" : "Activer mode sombre"}
      className="inline-flex h-8 w-8 sm:h-9 sm:w-9 shrink-0 items-center justify-center rounded-full border border-border bg-white/70 text-foreground/80 hover:text-[#FF5A1F] hover:border-[#FF5A1F]/40 transition-all"
    >
      {dark ? <Sun size={15} /> : <Moon size={15} />}
    </button>
  );
};

export default DarkModeToggle;
